<div class="topo-slider">
  <div
    fxLayout="row"
    fxLayoutAlign="space-between center">
    <label>{{ label }}</label>
    <label>{{ displayValue }}</label>
  </div>
  <mat-slider
    [min]="min"
    [max]="max"
    [step]="step"
    [attr.aria-label]="label">
    <input
      matSliderThumb
      [value]="value"
      (valueChange)="onValueChange($event)"
      (input)="onValueInput($event)"
      (dragStart)="isDragging = true"
      (dragEnd)="isDragging = false"
      [style.cursor]="isDragging ? 'grabbing' : 'grab'" />
  </mat-slider>
</div>
